<template>
  <div>
    <a-form :form="form">
      <a-card title="中期检查录入节点信息">
        <a-row type="flex" justify="space-between" align="top">
          <a-col :span="11">
            <a-form-item label="节点名称">
              <a-input v-decorator="['xmname', validatorRules.name]" placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="发布单位">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="项目发布人">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="开始提交时间">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="上传截止时间">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
      <a-card title="中期检查信息">
        <a-form-item label="说明">
          <a-textarea placeholder="请输入5000字以内的文字"></a-textarea>
        </a-form-item>
        <a-form-item label="绩效自评价报告（附件类型pdf，附件大小不超过3M，只需上传1份。）">
          <a-upload
            name="file"
            :multiple="true"
            listType="text"
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          >
            <a-button> <a-icon type="upload" /> 上传附件 </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item label="项目验收材料（附件类型pdf，附件大小不超过3M，不限个数。）">
          <a-upload
            name="file"
            :multiple="true"
            listType="text"
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          >
            <a-button> <a-icon type="upload" /> 上传附件 </a-button>
          </a-upload>
        </a-form-item>
      </a-card>
    </a-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
      validatorRules: {
        name: { rules: [{ required: true, message: '节点名称不能为空' }] },
      },
    }
  },
}
</script>

<style>
</style>